module.exports = __webpack_public_path__ + "static/media/roller09.68a6816e.jpg";